import { render, staticRenderFns } from "./New2019.vue?vue&type=template&id=40bc30a8&scoped=true&"
import script from "./New2019.vue?vue&type=script&lang=js&"
export * from "./New2019.vue?vue&type=script&lang=js&"
import style0 from "./New2019.vue?vue&type=style&index=0&id=40bc30a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc30a8",
  null
  
)

export default component.exports